<template>
  <o-form-wrapper
    v-model="item"
    :form-state="formState"
    :schema="schema"
    :server-errors="_se"
    :v="$v.item"
  >
    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="odometer"
    >
      <o-number-field
        v-model="item.odometer"
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="odometer"
        step="1"
        v-bind="schema.fields.odometer"
      ></o-number-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="general_visual_inspection"
    >
      <o-checkbox
        v-model="item.general_visual_inspection"
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="general_visual_inspection"
        v-bind="schema.fields.general_visual_inspection"
      ></o-checkbox>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="general_visual_comments"
    >
      <o-text-area
        v-model="item.general_visual_comments"
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="general_visual_comments"
        v-bind="schema.fields.general_visual_comments"
      ></o-text-area>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="tyres_inspection"
    >
      <o-checkbox
        v-model="item.tyres_inspection"
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="tyres_inspection"
        v-bind="schema.fields.tyres_inspection"
      ></o-checkbox>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="tyres_comments"
    >
      <o-text-area
        v-model="item.tyres_comments"
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="tyres_comments"
        v-bind="schema.fields.tyres_comments"
      ></o-text-area>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="head_lights_inspection"
    >
      <o-checkbox
        v-model="item.head_lights_inspection"
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="head_lights_inspection"
        v-bind="schema.fields.head_lights_inspection"
      ></o-checkbox>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="head_lights_comments"
    >
      <o-text-area
        v-model="item.head_lights_comments"
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="head_lights_comments"
        v-bind="schema.fields.head_lights_comments"
      ></o-text-area>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="tail_lights_inspection"
    >
      <o-checkbox
        v-model="item.tail_lights_inspection"
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="tail_lights_inspection"
        v-bind="schema.fields.tail_lights_inspection"
      ></o-checkbox>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="tail_lights_comments"
    >
      <o-text-area
        v-model="item.tail_lights_comments"
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="tail_lights_comments"
        v-bind="schema.fields.tail_lights_comments"
      ></o-text-area>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="side_lights_inspection"
    >
      <o-checkbox
        v-model="item.side_lights_inspection"
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="side_lights_inspection"
        v-bind="schema.fields.side_lights_inspection"
      ></o-checkbox>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="side_lights_comments"
    >
      <o-text-area
        v-model="item.side_lights_comments"
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="side_lights_comments"
        v-bind="schema.fields.side_lights_comments"
      ></o-text-area>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="comments"
    >
      <o-text-area
        v-model="item.comments"
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="comments"
        v-bind="schema.fields.comments"
      ></o-text-area>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="driver_id"
    >
      <o-select
        v-model="item.driver_id"
        :form-state="formState"
        :items="optionCodeTruckItems"
        :loading="optionCodeTruckWorking"
        :server-errors="_se"
        :validators="$v.item"
        add-title="Create New"
        allow-add
        name="driver_id"
        sort-field="name"
        store-name="CodeTruck"
        text-field="name"
        v-bind="schema.fields.driver_id"
        value-field="id"
      >
        <template slot="form" slot-scope="{ item, formState, serverErrors }">
          <code-truck-form
            :form-state="formState"
            :item="item"
            :server-errors="serverErrors"
            in-modal
          ></code-truck-form>
        </template>
      </o-select>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="active_start_date"
    >
      <o-date-time
        v-model="item.active_start_date"
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="active_start_date"
        v-bind="schema.fields.active_start_date"
      ></o-date-time>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="active_end_date"
    >
      <o-date-time
        v-model="item.active_end_date"
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="active_end_date"
        v-bind="schema.fields.active_end_date"
      ></o-date-time>
    </o-widget-wrapper>
  </o-form-wrapper>
</template>

<script>
import schema from "../../schema/index.js";
import {cleanUpModel} from "@/vue-ocom/schema/schema_vuetify.js";

import {CreateFormStateMixin, CreateGroupPermissionMixin, VuelidateMixin,} from "@/vue-ocom/mixins";
import {validationMixin} from "vuelidate";
import OWidgetWrapper from "@/vue-ocom/components/forms/OWidgetWrapper.vue";
import OTextField from "@/vue-ocom/components/forms/fields/OTextField.vue";
import ONumberField from "@/vue-ocom/components/forms/fields/ONumberField.vue";
import OTextArea from "@/vue-ocom/components/forms/fields/OTextarea.vue";
import OSelect from "@/vue-ocom/components/forms/fields/OSelect.vue";
import OCheckbox from "@/vue-ocom/components/forms/fields/OCheckbox.vue";
import OFormWrapper from "@/vue-ocom/components/forms/OFormWrapper.vue";
import ODateTime from "@/vue-ocom/components/forms/fields/ODateTime.vue";

import UseCodeModulesMixin from "@/vue-ocom/mixins/UseCodeModulesMixin.js";

import {default as CodeTruckForm} from "../../code_truck/components/ItemForm";

export default {
  mixins: [
    VuelidateMixin,
    validationMixin,
    CreateFormStateMixin("$v"),
    CreateGroupPermissionMixin("PreStartCheckList"),
    UseCodeModulesMixin(["CodeTruck"]),
  ],
  components: {
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,

    OCheckbox,
    OSelect,
    OTextField,
    OTextArea,
    ONumberField,

    CodeTruckForm,
  },
  props: {
    item: {
      type: Object, default: () => {
      }
    },
    level: {type: Number, default: 0},
    inModal: {type: Boolean, default: false},
  },
  data: () => ({
    schemaModel: cleanUpModel(schema.PreStartCheckList, {}),
  }),
  methods: {},
  computed: {
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    },
  },
  watch: {},
  created() {
  },
};
</script>
